export default __webpack_public_path__ + "media/images/react_icons/unchecked_checkbox-4128a1b9202420b4a3cdde4b11144006.svg";